import React from "react";
import { CheckIcon } from "../Icons";
import { Pricing } from "../business-case/calculator";
import { Section, SectionHeading, SectionLabel } from "../ui";

export default function IncludedGrid({ pricing }: { pricing: Pricing }) {
  return (
    <Section className="tw-bg-white">
      <div className="tw-grid tw-grid-cols-[.85fr_1.35fr] tw-items-start tw-gap-10 sm:tw-grid-cols-1 sm:tw-gap-8">
        <div>
          <SectionLabel>Included with the platform</SectionLabel>
          <SectionHeading size="compact">The workflow every programme needs.</SectionHeading>
          <p className="tw-mt-4 tw-mb-0 tw-text-base tw-leading-7 tw-text-[#5b7188]">
            Every platform plan includes the core tools your programme team needs. Customisation,
            integrations and bespoke reporting are scoped separately.
          </p>
        </div>

        <ul className="tw-m-0 tw-grid tw-list-none tw-grid-cols-2 tw-gap-3.5 tw-p-0 sm:tw-grid-cols-1">
          {pricing.platformIncludes.map((item) => (
            <li
              key={item}
              className="tw-flex tw-items-center tw-gap-3 tw-rounded-2xl tw-border tw-border-[#dfeaf4] tw-bg-[#f4f9fd] tw-px-5 tw-py-4 tw-text-sm tw-font-bold tw-text-[#314b64]"
            >
              {/* Darker than the brand green so the tick clears 3:1 against the tile, not just white. */}
              <CheckIcon aria-hidden className="tw-h-4 tw-w-4 tw-shrink-0 tw-text-[#12967a]" />
              {item}
            </li>
          ))}
        </ul>
      </div>
    </Section>
  );
}
